export const getWindowDpr = () => {
  return window.devicePixelRatio;
};
